import { createSelector } from 'reselect';
import { filter, flow, map, orderBy, path, values } from 'lodash/fp';

/**
 * @type {Function}
 */
const getPropertyObjectsSlice = createSelector(path('app.propertyObjects'), (slice) =>
  slice.toJS(),
);

/**
 * @type {Function}
 */
export const getPropertyObjectsData = flow(getPropertyObjectsSlice, path('data'));

/**
 * @type {Function}
 */
export const getAllObjects = createSelector(
  getPropertyObjectsData,
  flow(values, orderBy(['registrationDate', 'id'], ['desc', 'desc'])),
);

/**
 * @type {Function}
 */
export const getAllClearObjects = createSelector(getAllObjects, map(path('originalProperties')));

/**
 * @type {Function}
 */
export const getRealEstateObjects = createSelector(
  getAllObjects,
  filter((object) => object.isRealEstate()),
);

/**
 * Get realty objects
 * @type {OutputSelector<unknown, unknown[], (res: (ArrayLike<unknown> | object | null | undefined)) => unknown[]>}
 */

export const getRealtyObjects = createSelector(getRealEstateObjects, (objects) => {
  return objects.filter((object) => {
    if (object.propertyType === 1) {
      return /^(3010|3020|3021|3070)/.test(object.sntsCode);
    }

    if (object.propertyType === 2) {
      return true;
    }

    return false;
  });
});

/**
 * Select property objects loading state
 * @type {Function}
 */
export const selectPropertyObjectsLoading = createSelector(
  getPropertyObjectsSlice,
  ({ loading }) => loading,
);
